const useProductHasSurchargeModifier = menuItemDetails => {
  const modifier_groups = menuItemDetails?.modifier_groups || [];

  const hasSurchargeModifier = modifier_groups.some(modifier =>
    modifier.options?.some(option => parseFloat(option.price_variance || 0) > 0)
  );

  return hasSurchargeModifier;
};

export default useProductHasSurchargeModifier;
